var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ring"},_vm._l((4),function(ring,index){return _c('div',{key:index})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }